<template>
    <section>
        <p class='mb-0'>Комментарий:</p>
        <b-form-textarea
            id="comment-textarea"
            v-model="_commentText"
            placeholder="Добавьте комментарий..."
            rows="6"
        ></b-form-textarea>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'call-comment',
    methods: {
        ...mapActions('covid', [
            'updateComment'
        ])
    },
    computed: {
        ...mapState({
            commentText: state => state.covid.commentText,
        }),
        _commentText: {
            get() { return this.commentText },
            set(value) { this.updateComment(value) }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CallComment.vue